import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    width: 90%;
    max-width: 440px;
    padding: 1.5rem;
    background: rgba(30, 27, 75, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(16px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    color: rgba(255, 255, 255, 0.85);
    max-height: 60vh;
    overflow-y: auto;

    & > p {
        text-align: center;
        color: rgba(255, 255, 255, 0.45);
        font-size: 0.9rem;
        padding: 1rem 0;
    }

    &::-webkit-scrollbar { width: 5px; }
    &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
`;

const OnlineUserItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0.4rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);

    &:last-child { border-bottom: none; }

    & span {
        font-size: 0.88rem;
        color: rgba(255, 255, 255, 0.7);
    }
`;

const InviteButton = styled.button`
    padding: 0.4rem 1rem;
    border-radius: 10px;
    border: none;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: white;
    box-shadow: 0 2px 10px rgba(99, 102, 241, 0.3);

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(99, 102, 241, 0.45);
    }
    &:active { transform: translateY(0); }

    &:disabled {
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.3);
        box-shadow: none;
        cursor: not-allowed;
        transform: none;
    }
`;

const OnlineUsersModal = ({ currentUserId, onlineUsers, onClose, isOpen, onInvite }) => {
    const [invitedUsers, setInvitedUsers] = useState(new Set());
    const { t } = useTranslation();

    const handleInvite = (userId) => {
        setInvitedUsers(prevState => new Set(prevState.add(userId)));
        onInvite(userId);
        setTimeout(() => {
            setInvitedUsers(prevState => new Set([...prevState].filter(id => id !== userId)));
        }, 60000);
    };

    const filteredUsers = Array.isArray(onlineUsers) ? onlineUsers.filter(user => user.id !== currentUserId) : [];

    return (
        isOpen && (
            <ModalOverlay onClick={onClose}>
                <ModalContent onClick={e => e.stopPropagation()}>
                    {filteredUsers.length > 0 ?
                        filteredUsers.map(user => (
                            <OnlineUserItem key={user.id}>
                                <span>{user.username} ({user.language})</span>
                                <InviteButton
                                    disabled={invitedUsers.has(user.id)}
                                    onClick={() => handleInvite(user.id)}
                                >
                                    {invitedUsers.has(user.id) ? t('OnlineUserInviteSentButton') : t('OnlineUserInviteButton')}
                                </InviteButton>
                            </OnlineUserItem>
                        ))
                        :
                        <p>{t('ChatOnlineUserModalNoUsers')}</p>
                    }
                </ModalContent>
            </ModalOverlay>
        )
    );
};

export default OnlineUsersModal;
